<!-- 
Dialog for entering levy parameters into the levy calculator playground
-->
<template>
  <v-dialog 
    :value="show" persistent scrollable content-class="dialog lg" 
    @keydown.esc="cancel"
  >
    <playground-parameters-panel
      :levy-collection="levyCollection"
      :buttons-disabled="state.loading"
      @click:recalculate="recalculate"
      @click:reset="reset"
      @click:cancel="hide"
    >
      <template slot="toolbar">
        <v-toolbar color="secondary" flat dark>
          <v-toolbar-title>Levy estimator</v-toolbar-title>
        </v-toolbar>
        <our-busy-indicator :show="state.loading"/>
      </template>
    </playground-parameters-panel>
  </v-dialog>
</template>

<script>
import PlaygroundParametersPanel from "./PlaygroundParametersPanel.vue";
import * as action from "@/store/levy-estimator/action-types";
import * as mutation from "@/store/levy-estimator/mutation-types";

export default {
  components: { PlaygroundParametersPanel },
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    levyCollection: {
      type: Object,
      default: null
    },
    estimatorKey: {
      validator: prop => typeof prop === "string" || prop === null,
      required: true
    }
  },
  computed: {
    state() {
      return this.$store.state.levyEstimator.playground;
    },
    levyCollectionYear() {
      return this.levyCollection ? this.levyCollection.year : 0;
    },
    levyCollectionType() {
      return this.levyCollection ? this.levyCollection.type : "";
    },
    levyCollectionTypeDescription() {
      return this.levyCollectionType.toUpperCase();
    }
  },
  watch: {
    show(nowShowing) {
      if (nowShowing) {
        this.$store.commit(mutation.PLAYGROUND_EDIT_START, this.estimatorKey);
      }
    }
  },
  methods: {
    reset() {
      this.$store.commit(mutation.PLAYGROUND_EDIT_RESET);
    },
    async recalculate() {
      this.$store.commit(mutation.PLAYGROUND_EDIT_APPLY);
      await this.$store.dispatch(action.PLAYGROUND_CALCULATE, this.estimatorKey);
      this.hide();
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
